module.exports = __webpack_public_path__ + "media/images/icon_li_gray-593e3b2b1a07a5e14805c5bfc09e688f.png";